<template>
    <v-footer
        fixed height="74"
        color="white" :class="['footer-gradient', {'desktop': !isMobile}]"
        :style="`background-size: ${percent}% 100%`"
    >
        <div class="percentage">
            {{ percent }}%
        </div>
    </v-footer>
</template>

<script>

import {mapState} from 'vuex'

export default {
    props: {
        percent: {
            type: Number,
            default: 0
        },
    },
}
</script>

<style scoped>

.percentage {
    font-size: 30px;
    font-weight: bold;
}

.footer-gradient {
    background: transparent linear-gradient(182deg, rgba(213, 254, 70, 0.5) 0%, rgba(105, 217, 199, 0.5) 100%) 0 0 no-repeat padding-box;
    border-top: 1px solid rgba(213, 254, 70, 0.5) !important;
    box-shadow: 0 -3px 6px #003E5128;
    z-index: 5;
}

.footer-gradient.desktop{
    left: 56px !important;
}

</style>